import { QUERY_KEYS } from "config/queryKeys";

const invalidate = (queryClient, queryKey) => {
  if (!queryClient || !queryKey) return;

  queryClient.invalidateQueries({ queryKey });
};

export const invalidateDashboardSources = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.invoices.all);
  invalidate(queryClient, QUERY_KEYS.payments.all);
  invalidate(queryClient, QUERY_KEYS.refunds.all);
  invalidate(queryClient, QUERY_KEYS.creditNotes.all);
  invalidate(queryClient, QUERY_KEYS.purchaseOrders.all);
  invalidate(queryClient, QUERY_KEYS.clients.all);
  invalidate(queryClient, QUERY_KEYS.vendors.all);
  invalidate(queryClient, QUERY_KEYS.products.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};

export const invalidateSalesSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.invoices.all);
  invalidate(queryClient, QUERY_KEYS.payments.all);
  invalidate(queryClient, QUERY_KEYS.refunds.all);
  invalidate(queryClient, QUERY_KEYS.creditNotes.all);
  invalidate(queryClient, QUERY_KEYS.clients.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
  invalidate(queryClient, QUERY_KEYS.clientCreditApplications.all);
};

export const invalidateInvoiceSide = invalidateSalesSide;

export const invalidatePaymentSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.payments.all);
  invalidate(queryClient, QUERY_KEYS.invoices.all);
  invalidate(queryClient, QUERY_KEYS.clients.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
  invalidate(queryClient, QUERY_KEYS.clientCreditApplications.all);
};

export const invalidateRefundSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.refunds.all);
  invalidate(queryClient, QUERY_KEYS.invoices.all);
  invalidate(queryClient, QUERY_KEYS.clients.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
  invalidate(queryClient, QUERY_KEYS.clientCreditApplications.all);
};

export const invalidateCreditNoteSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.creditNotes.all);
  invalidate(queryClient, QUERY_KEYS.clients.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};

export const invalidateClientSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.clients.all);
  invalidate(queryClient, QUERY_KEYS.invoices.all);
  invalidate(queryClient, QUERY_KEYS.payments.all);
  invalidate(queryClient, QUERY_KEYS.refunds.all);
  invalidate(queryClient, QUERY_KEYS.creditNotes.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};

export const invalidateProductSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.products.all);
};

export const invalidateVendorSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.vendors.all);
  invalidate(queryClient, QUERY_KEYS.purchaseOrders.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};

export const invalidatePurchaseSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.purchaseOrders.all);
  invalidate(queryClient, QUERY_KEYS.vendors.all);
  invalidate(queryClient, QUERY_KEYS.products.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};

export const invalidatePurchasePaymentSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.purchasePayments.all);
  invalidate(queryClient, QUERY_KEYS.vendors.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};

export const invalidatePurchaseRefundSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.purchaseRefunds.all);
  invalidate(queryClient, QUERY_KEYS.vendors.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};

export const invalidatePurchaseCreditNoteSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.purchaseCreditNotes.all);
  invalidate(queryClient, QUERY_KEYS.vendors.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};

export const invalidateExpenseSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.expenses.all);
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};

export const invalidateDeviceSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.devices.all);
};

export const invalidateAccountingSide = (queryClient) => {
  invalidate(queryClient, QUERY_KEYS.accounting.all);
};
